import React, { useState, useRef } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import FunctionService from "../../../services/function.service";
import { Card } from "../../../components/Card/Card";
import { useToast } from "../../../hooks";
import styles from "../../Purchase/General/styles.module.scss";
import { updateLocalStorageCache } from "../../../utils/Service";

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        El campo es obligatorio!
      </div>
    );
  }
};

const FunctionsCreate = (props) => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [title, setTitle] = useState("");
  const [link, setLink] = useState("");
  const [position, setPosition] = useState(0);
  const [loading, setLoading] = useState(false);

  const form = useRef();
  const checkBtn = useRef();
  const addToast = useToast();

  const handSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      const params = {
        name,
        description,
        title,
        position,
        link,
        icon: "pe-7s-car", //icono por defecto
      };
      FunctionService.create(params).then(
        () => {
          addToast({
            variant: "success",
            header: "Funciones",
            body: "Se creó la nueva función correctamente",
          });
          updateLocalStorageCache().then(() => {
            navigate("/admin/functions/list");
          });
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          setLoading(false);
          addToast({
            variant: "danger",
            header: "Funciones",
            body: resMessage,
          });
        }
      );
    } else {
      setLoading(false);
    }
  };

  return (
    <div className="content">
      <Container fluid>
        <div className={`content-filters form-group ${styles.lessHeight}`}>
          <Button href="/admin/functions/list" variant="outline-primary">
            Volver
          </Button>
        </div>
        <br />
        <Row>
          <Col md={12}>
            <Card
              content={
                <Form onSubmit={handSubmit} ref={form}>
                  <div className="form-group">
                    <label>Nombre</label>
                    <Input
                      type="text"
                      className="form-control"
                      name="name"
                      placeholder="Nombre"
                      onChange={(e) => setName(e.target.value)}
                      validations={[required]}
                    />
                  </div>

                  <div className="form-group">
                    <label>Descripción</label>
                    <Input
                      type="text"
                      className="form-control"
                      name="description"
                      placeholder="description"
                      onChange={(e) => setDescription(e.target.value)}
                      validations={[required]}
                    />
                  </div>

                  <div className="form-group">
                    <label>Título</label>
                    <Input
                      type="text"
                      className="form-control"
                      name="title"
                      placeholder="Título"
                      onChange={(e) => setTitle(e.target.value)}
                      validations={[required]}
                    />
                  </div>

                  <div className="form-group">
                    <label>Link / URL</label>
                    <Input
                      type="text"
                      className="form-control"
                      name="link"
                      placeholder="Link / URL"
                      onChange={(e) => setLink(e.target.value)}
                      validations={[required]}
                    />
                  </div>

                  <div className="form-group">
                    <label>Posición</label>
                    <Input
                      type="number"
                      className="form-control"
                      name="position"
                      placeholder="Posición"
                      onChange={(e) => setPosition(e.target.value)}
                      validations={[required]}
                    />
                  </div>

                  <div className="form-group mt-3">
                    <button
                      className="btn btn-primary btn-fill pull-right"
                      disabled={loading}
                    >
                      {loading && (
                        <span className="spinner-border spinner-border-sm"></span>
                      )}
                      <span>Crear Función</span>
                    </button>
                  </div>

                  <CheckButton style={{ display: "none" }} ref={checkBtn} />

                  <div className="clearfix" />
                </Form>
              }
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FunctionsCreate;
